import { SUPABASE_FUNCTIONS_URL, SUPABASE_ANON, supabase } from "./supabase";
import type { StartResponse } from "./types";

async function callFn<T = any>(name: string, body: unknown): Promise<T> {
  const r = await fetch(`${SUPABASE_FUNCTIONS_URL}/${name}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", apikey: SUPABASE_ANON, Authorization: `Bearer ${SUPABASE_ANON}` },
    body: JSON.stringify(body),
  });
  let j: any = {};
  try { j = await r.json(); } catch { /* ignore */ }
  if (!r.ok) throw new Error(j?.error || `HTTP ${r.status}`);
  return j as T;
}

export const assessmentStart = (token: string) => callFn<StartResponse>("assessment-start", { token });
export const answerAutosave = (b: Record<string, unknown>) => callFn("answer-autosave", b);
export const signUpload = (b: Record<string, unknown>) => callFn("sign-upload", b);
export const assessmentSubmit = (b: Record<string, unknown>) => callFn("assessment-submit", b);

export async function sha256Hex(file: Blob): Promise<string> {
  const buf = await file.arrayBuffer();
  const h = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(h)).map((x) => x.toString(16).padStart(2, "0")).join("");
}

export async function uploadArtifact(opts: {
  session_id: string; token: string; question_id: string;
  kind: "audio" | "file"; file: File | Blob; file_name: string; duration_sec?: number;
}): Promise<string> {
  const sha = opts.kind === "file" ? await sha256Hex(opts.file) : undefined;
  const sign: any = await signUpload({
    action: "sign", session_id: opts.session_id, token: opts.token, question_id: opts.question_id,
    kind: opts.kind, file_name: opts.file_name, mime_type: (opts.file as any).type || "application/octet-stream",
    size_bytes: (opts.file as any).size || 0,
  });
  const { error } = await supabase.storage.from(sign.bucket).uploadToSignedUrl(sign.path, sign.token, opts.file);
  if (error) throw error;
  await signUpload({
    action: "register", session_id: opts.session_id, token: opts.token, question_id: opts.question_id,
    kind: opts.kind, path: sign.path, file_name: opts.file_name,
    mime_type: (opts.file as any).type || null, size_bytes: (opts.file as any).size || null,
    sha256: sha, duration_sec: opts.duration_sec,
  });
  return sign.path;
}
